// react core
import React, { useEffect, useState } from 'react';

// components
import RedirectTo from 'components/commons/redirect_to';

// conf
import conf from 'conf/config';
import usePageTitle from 'utils/page_title';

// This route currently behaves as a technical post-login redirect page:
// it forwards authenticated users to came_from or to the default landing page,
// and otherwise shows a forbidden state. During code review we found no active
// frontend links targeting /auth/userinfo, so it may be a legacy compatibility
// route kept for older backend/SSO flows. Before removing or renaming it,
// validate real usage via Apache/access logs or temporary analytics tracking.
export default function InfoPage({user})
{
    const [user_data, set_user_data] = useState(user);
    const has_came_from = user_data && 'came_from' in user_data && user_data.came_from !== null;
    const is_logged = user_data && user_data.ok === true;
    usePageTitle((has_came_from || is_logged) ? 'Redirecting' : 'Forbidden');
      // Similar to componentDidMount and componentDidUpdate:
    useEffect(() =>
    {
        set_user_data(user);
        console.log('u => ' + JSON.stringify(user));
    }, [user]);

    // logged flag
    if('came_from' in user_data && user_data.came_from !== null)
    {
        return (
            <RedirectTo url={user_data.came_from}/>
        );
    }
    else
    {
        if(user_data.ok === true)
        {
            return (
                <RedirectTo url={conf.server.default_redirect_after_login} />
            );
        }
        else
        {
            return (
                <div>Forbidden</div>
            )
        }
    }
};
